module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h1', {
    staticClass: "section",
    attrs: {
      "id": "sect7"
    }
  }, [_c('a', {
    attrs: {
      "id": "page16"
    }
  }), _c('span', {
    attrs: {
      "href": "#/OEBPS/toc#sect7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Breakfast Stuffed Peppers")])]), _vm._v(" "), _c('p', {
    staticClass: "figure"
  }, [_c('img', {
    staticStyle: {
      "height": "70vh"
    },
    attrs: {
      "alt": "",
      "src": "OEBPS/images/17-1.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "RecipebYieldb"
  }, [_vm._v("Yield: Serves 6 | Prep Time: 15 minutes | Cook Time: 45 minutes")]), _vm._v(" "), _c('p', {
    staticClass: "extract_r"
  }, [_vm._v("Yes, stuffed peppers are typically made for dinner. But you find bell peppers in omelets and breakfast skillets, so why can’t you change the format of the ingredients to make a breakfast version of stuffed peppers? Plus, you get even more veggies than you normally would with each serving.")]), _vm._v(" "), _c('p', {
    staticClass: "ingredients"
  }, [_c('strong', [_vm._v("INGREDIENTS")])]), _vm._v(" "), _c('p', {
    staticClass: "rec"
  }, [_vm._v("3 large red or yellow bell peppers (or a combination of colors)")]), _vm._v(" "), _c('p', {
    staticClass: "rec"
  }, [_vm._v("½ pound ground turkey sausage")]), _vm._v(" "), _c('p', {
    staticClass: "rec"
  }, [_vm._v("3 tablespoons olive oil")]), _vm._v(" "), _c('p', {
    staticClass: "rec"
  }, [_vm._v("1–2 red potatoes, peeled and finely diced (1 cup)")]), _vm._v(" "), _c('p', {
    staticClass: "rec"
  }, [_vm._v("1–2 sweet potatoes, peeled and finely diced (1 cup)")]), _vm._v(" "), _c('p', {
    staticClass: "rec"
  }, [_vm._v("½ cup finely minced shallots")]), _vm._v(" "), _c('p', {
    staticClass: "rec"
  }, [_vm._v("1 tablespoon minced garlic")]), _vm._v(" "), _c('p', {
    staticClass: "rec"
  }, [_vm._v("1 tablespoon Italian seasoning")]), _vm._v(" "), _c('p', {
    staticClass: "rec"
  }, [_vm._v("1 tablespoon fresh thyme")]), _vm._v(" "), _c('p', {
    staticClass: "rec"
  }, [_vm._v("½ teaspoon kosher salt")]), _vm._v(" "), _c('p', {
    staticClass: "rec"
  }, [_vm._v("¼ teaspoon freshly ground black pepper")]), _vm._v(" "), _c('p', {
    staticClass: "rec"
  }, [_vm._v("1 tablespoon maple syrup")]), _vm._v(" "), _c('p', {
    staticClass: "rec"
  }, [_vm._v("6 large eggs, whisked together")]), _vm._v(" "), _c('p', {
    staticClass: "rec"
  }, [_vm._v("½ cup shredded low-fat Colby Jack cheese")]), _vm._v(" "), _c('p', {
    staticClass: "directions"
  }, [_c('strong', [_vm._v("DIRECTIONS")])]), _vm._v(" "), _c('p', {
    staticClass: "recpr"
  }, [_vm._v("1. Preheat the oven to 375°F. Lightly coat a baking dish with cooking spray.")]), _vm._v(" "), _c('p', {
    staticClass: "recpr"
  }, [_vm._v("2. Slice the peppers in half through the top of the stem. Remove the seeds and interior membrane. Rinse and dry the peppers. Place cut-side up in the baking dish.")]), _vm._v(" "), _c('p', {
    staticClass: "recpr"
  }, [_vm._v("3. In a medium skillet, cook the sausage for about 3 minutes, until fully cooked. Remove to a large bowl.")]), _vm._v(" "), _c('p', {
    staticClass: "recpr"
  }, [_vm._v("4. Wipe out the skillet, add the olive oil, and warm over medium-high heat.")]), _vm._v(" "), _c('p', {
    staticClass: "recpr"
  }, [_vm._v("5. Add the red potatoes, sweet potatoes, and shallots. Then add the garlic, Italian seasoning, thyme, salt, and black pepper. Cook for 5 minutes.")]), _vm._v(" "), _c('p', {
    staticClass: "recpr"
  }, [_vm._v("6. Remove the potato mixture from the heat and add to the bowl with the sausage. Mix in the maple syrup.")]), _vm._v(" "), _c('p', {
    staticClass: "recpr"
  }, [_vm._v("7. Fill each pepper three-quarters full with the sausage and potato mixture.")]), _vm._v(" "), _c('p', {
    staticClass: "recpr"
  }, [_vm._v("8. Add some of the whisked egg to the top of each of the peppers.")]), _vm._v(" "), _c('p', {
    staticClass: "recpr"
  }, [_vm._v("9. Bake for 35 minutes or until the eggs have set.")]), _vm._v(" "), _c('p', {
    staticClass: "recpr"
  }, [_vm._v("10. Sprinkle each pepper with the Colby Jack cheese. Serve.")]), _vm._v(" "), _c('p', {
    staticClass: "notehead"
  }, [_c('strong', [_vm._v("NOTES")])]), _vm._v(" "), _c('p', {
    staticClass: "NotebText"
  }, [_vm._v("If the peppers will not sit up straight in the baking dish, place some crumpled foil between them to prop them up.")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-095a6072","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/OEBPS/sect7.vue
// module id = 105
// module chunks = 0